import ContentOverlay from "../components/content_overlay";
import {Link} from "react-router-dom";
import "./abstract.css";

function ForumPage(){
    return (
        <ContentOverlay
        heading={ <h3 style={{textAlign:"center"}}>Forum</h3>}
        text_content={<div>
          <p><u><strong>International Level</strong></u></p>
            <ol><li>
            <p ><strong>Global Urban Heat Island Research Network (GUHIN)</strong></p>
           
            <p ><u><a href="https://ghhin.org/"><strong>https://ghhin.org/</strong></a></u></p>
            </li></ol>
            <ol start="2">
            <li>
            <p ><strong>UN Climate Change</strong></p>
           
            <p ><u><a href="https://unfccc.int/"><strong>https://unfccc.int/</strong></a></u></p>
            </li></ol>
            <ol start="3">
            <li>
            <p ><strong>Climate Action Tracker</strong></p>
           
            <p ><u><a href="https://climateactiontracker.org/"><strong>https://climateactiontracker.org/</strong></a></u></p>
            </li></ol>
            <ol start="4">
            <li>
            <p ><strong>Intergovernmental Panel on Climate Change (IPCC)</strong></p>
           
            <p ><u><a href="https://www.ipcc.ch/"><strong>https://www.ipcc.ch/</strong></a></u></p>
            </li></ol>
            <ol start="5">
            <li>
            <p ><strong>Potsdam Institute for Climate Impact Research (PIK)</strong></p>
           
            <p ><u><a href="https://www.pik-potsdam.de/en/"><strong>https://www.pik-potsdam.de/en/</strong></a></u></p>
            </li></ol>
            <ol start="6">
            <li>
            <p ><strong>C40 Cities Climate Leadership Group</strong></p>
           
            <p ><u><a href="https://www.c40.org/"><strong>https://www.c40.org/</strong></a></u></p>
            </li></ol>
            <ol start="7">
            <li>
            <p ><strong>Climate Action Network South Asia (CANSA)</strong></p>
           
            <p ><u><a href="https://cansouthasia.net/"><strong>https://cansouthasia.net/</strong></a></u></p>
            </li></ol>
            <ol start="8">
            <li>
            <p ><strong>Center for Climate and Energy Solutions</strong></p>
           
            <p ><u><a href="https://www.c2es.org/"><strong>https://www.c2es.org/</strong></a></u></p>
            </li></ol>
            <ol start="9">
            <li>
            <p ><strong>Climate Group</strong></p>
           
            <p ><u><a href="https://www.theclimategroup.org/"><strong>https://www.theclimategroup.org</strong></a></u></p></li></ol>
            <ol start="10">
            <li>
            <p ><strong>RS lab</strong></p>
           
            <p ><u><a href="https://rslab.gr/"><strong>https://rslab.gr/</strong></a></u></p>
            </li></ol>
            <ol start="11">
            <li>
            <p ><strong>European Association of Remote Sensing Laboratories (EARSeL)</strong></p>
           
            <p ><u><a href="https://thermal-rs.earsel.org/"><strong>https://thermal-rs.earsel.org/</strong></a></u></p>
            </li></ol>
            
           <p><u><strong>National Level</strong></u></p>
            <ol>
            <li>
            <p ><strong>Energy and Wetlands Research </strong></p>
           
            <p ><u><a href="https://wgbis.ces.iisc.ac.in/energy/"><strong>https://wgbis.ces.iisc.ac.in/energy/</strong></a></u></p>
            </li></ol>
            <ol start="2">
            <li>
            <p  ><strong>Centre for Climate Change Research</strong></p>
           
            <p ><u><a href="http://cccr.tropmet.res.in/"><strong>http://cccr.tropmet.res.in/</strong></a></u></p>
            </li></ol>
            <ol start="3">
            <li>
            <p ><strong>Centre for Climate Studies</strong></p>
           
            <p ><u><a href="https://www.climate.iitb.ac.in/"><strong>https://www.climate.iitb.ac.in/</strong></a></u></p>
          </li></ol>
            <ol start="4">
            <li>
            <p ><strong>Divecha Centre for Climate Change</strong></p>
           
            <p ><u><a href="http://dccc.iisc.ac.in/"><strong>http://dccc.iisc.ac.in/</strong></a></u></p>
          </li></ol>
            <ol start="5">
            <li>
            <p ><strong>Climate Group</strong></p>
           
            <p ><u><a href="https://www.theclimategroup.org/climate-group-india"><strong>https://www.theclimategroup.org/climate-group-india</strong></a></u></p>
          </li></ol>
            <ol start="6">
            <li>
            <p ><strong>Greenpeace </strong></p>
           
            <p ><u><a href="https://www.greenpeace.org/india/en/"><strong>https://www.greenpeace.org/india/en/</strong></a></u></p>
          </li></ol>
            <ol start="7">
            <li>
            <p ><strong>The Energy and Resources Institute (TERI)</strong></p>
           
            <p ><u><a href="https://www.teriin.org/"><strong>https://www.teriin.org/</strong></a></u></p>
            </li></ol>
          
            <ol start="8">
            <li>
            <p ><strong>Centre for Ocean, River, Atmosphere and Land Sciences (CORAL)</strong></p>
           
            <p ><u><a href="https://www.iitkgp.ac.in/department/CL"><strong>https://www.iitkgp.ac.in/department/CL</strong></a></u></p>
          </li></ol>
            <ol start="9">
            <li>
            <p ><strong>Space Application Centre</strong></p>
           
            <p ><u><a href="https://www.sac.gov.in/Vyom/"><strong>https://www.sac.gov.in/Vyom/</strong></a></u></p>
          </li></ol>
            <ol start="10">
            <li>
            <p ><strong>Indian Space Research Organization</strong></p>
           
            <p ><u><a href="https://www.isro.gov.in/"><strong>https://www.isro.gov.in/</strong></a></u></p>
            </li></ol>
           </div>}
        />

    )
}
export default ForumPage;